import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const TRUST_REPUTATION_VOCABULARIES = [
    vocabulary('occurrence.audience', '@vello/api-client OccurrenceAudienceView', {
        RIDER: L('Só passageiros', 'Riders only', 'Solo pasajeros', 'Solo passeggeri'),
        DRIVER: L('Só motoristas', 'Drivers only', 'Solo conductores', 'Solo autisti'),
        BOTH: L('Passageiros e motoristas', 'Riders and drivers', 'Pasajeros y conductores', 'Passeggeri e autisti'),
    }),
];
//# sourceMappingURL=trust-reputation.js.map